import React, { useEffect, useState } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import Button from "../Button";
import Input from "../Input";

export default function ProductBarcodeForm({ handleBarcodeSubmit, closeForm, show }) {
  const [barcodeText, setBarcodeText] = useState("");

  const onSubmit = e => {
    console.log("hi");
    e.preventDefault();
    handleBarcodeSubmit({
      body: barcodeText
    }).then(() => {
      setBarcodeText("");
      closeForm();
    });
  };

  return (
    <div className="">
      {show && (
        <form>
          <div style={{ maxWidth: 600, margin: "0 auto", marginTop: 30, marginBottom: 30 }}>
            <div className="row">
              <div className="col-sm-8">
                <Input
                  className="form-control"
                  placeholder="Input barcode here..."
                  onChange={e => setBarcodeText(e.target.value)}
                  onPressEnter={onSubmit}
                  value={barcodeText}
                  style={{ width: "100%", marginBottom: "6px" }}
                />
              </div>
              <div className="col-sm-2">
                <Button
                  primary
                  title={I18n.t("add_barcode")}
                  style={{ marginLeft: "4px", marginBottom: 0 }}
                  onClick={onSubmit}
                />
              </div>
              <div className="col-sm-2">
                <Button
                  title={I18n.t("cancel")}
                  onClick={closeForm}
                  style={{ marginLeft: "4px", marginBottom: 0 }}
                />
              </div>
            </div>
            <p className="small">
              Adding product barcodes allows you to speed up the registration process by
              scanning your barcodes to quickly filter the product list.
            </p>
          </div>
        </form>
      )}
    </div>
  );
}
